import { render, staticRenderFns } from "./topicDetails.vue?vue&type=template&id=45b732d6&scoped=true&"
import script from "./topicDetails.vue?vue&type=script&lang=js&"
export * from "./topicDetails.vue?vue&type=script&lang=js&"
import style0 from "./topicDetails.vue?vue&type=style&index=0&id=45b732d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b732d6",
  null
  
)

export default component.exports